var o = Object.defineProperty;
var p = (s, t, n) => t in s ? o(s, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : s[t] = n;
var e = (s, t, n) => p(s, typeof t != "symbol" ? t + "" : t, n);
import { HttpClient as r, httpClient as i } from "../../httpClient.js";
class c extends r {
  constructor() {
    super(...arguments);
    e(this, "endpoint", "/users/current-user");
  }
  async checkCoupon(n) {
    return i.post("/coupons/check", { code: n });
  }
  async createSubscription(n) {
    return i.post(`${this.endpoint}/subscription`, n);
  }
}
const b = new c();
export {
  b as default
};
